import FormControl from "@material-ui/core/FormControl";
import InputAdornment from "@material-ui/core/InputAdornment";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import classes from "./SignUpPage.module.scss";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import IconButton from "@material-ui/core/IconButton";

const SignUpOne = ({
  handleChange,
  first_name,
  last_name,
  email,
  password,
  passwordValidations,
  validNumber,
  validOneUpperCase,
  validOneDot,
  validEightCharacter,
  emailValidations,
  isCommonPassword,
}) => {
  const [passwordBlur, setPasswordBlur] = useState(false);
  const [emailBlur, setEmailBlur] = useState(false);
  const { t, i18n } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className={classes.inputRoot}>
      <div
        className={
          i18n.language === "fa"
            ? classes.outlinedInputRtl
            : classes.outlinedInputLtr
        }
      >
        <FormControl variant="outlined">
          <OutlinedInput
            autoComplete="section-signup name"
            id="outlined-adornment-weight"
            name="first_name"
            onChange={(event) => handleChange(event)}
            defaultValue={first_name}
            startAdornment={
              i18n.language === "fa" && (
                <InputAdornment position="start" disablePointerEvents={true}>
                  {t("sign_up.name")}
                </InputAdornment>
              )
            }
            endAdornment={
              i18n.language === "en" && (
                <InputAdornment position="end" disablePointerEvents={true}>
                  {t("sign_up.name")}
                </InputAdornment>
              )
            }
          />
        </FormControl>
      </div>
      <div
        className={
          i18n.language === "fa"
            ? classes.outlinedInputRtl
            : classes.outlinedInputLtr
        }
      >
        <FormControl variant="outlined">
          <OutlinedInput
            autoComplete="section-signup family-name"
            id="outlined-adornment-weight"
            name="last_name"
            onChange={(event) => handleChange(event)}
            defaultValue={last_name}
            startAdornment={
              i18n.language === "fa" && (
                <InputAdornment position="start" disablePointerEvents={true}>
                  {t("sign_up.last_name")}
                </InputAdornment>
              )
            }
            endAdornment={
              i18n.language === "en" && (
                <InputAdornment position="end" disablePointerEvents={true}>
                  {t("sign_up.last_name")}
                </InputAdornment>
              )
            }
          />
        </FormControl>
      </div>
      <div className={classes.outlinedInput}>
        <FormControl variant="outlined">
          <OutlinedInput
            autoComplete="section-signup username"
            dir="ltr"
            type="email"
            id="emailId"
            name="email"
            onChange={(event) => handleChange(event)}
            value={email}
            onBlur={() => {
              setEmailBlur(true);
            }}
            error={emailBlur && !emailValidations}
            endAdornment={
              i18n.language === "fa" && (
                <InputAdornment position="start" disablePointerEvents={true}>
                  {t("sign_up.email")}
                </InputAdornment>
              )
            }
            startAdornment={
              i18n.language === "en" && (
                <InputAdornment position="start" disablePointerEvents={true}>
                  {t("sign_up.email")}
                </InputAdornment>
              )
            }
          />
        </FormControl>
      </div>
      <div className={classes.outlinedInput}>
        <FormControl variant="outlined">
          <OutlinedInput
            dir="ltr"
            autoComplete="section-signup new-password"
            type={showPassword ? "text" : "password"}
            id="emailId"
            name="password"
            onBlur={() => setPasswordBlur(true)}
            onChange={(event) => handleChange(event)}
            defaultValue={password}
            error={passwordBlur && !passwordValidations}
            endAdornment={
              i18n.language === "fa" && (
                <InputAdornment position="start" style={{ padding: "0 6px" }}>
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                  >
                    {showPassword ? (
                      <AiOutlineEye />
                    ) : (
                      <AiOutlineEyeInvisible />
                    )}
                  </IconButton>
                  <p>{t("sign_up.password")}</p>
                </InputAdornment>
              )
            }
            startAdornment={
              i18n.language === "en" && (
                <InputAdornment position="start">
                  {t("sign_up.password")}
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                  >
                    {showPassword ? (
                      <AiOutlineEye />
                    ) : (
                      <AiOutlineEyeInvisible />
                    )}
                  </IconButton>
                </InputAdornment>
              )
            }
          />
        </FormControl>
        {isCommonPassword && (
          <p className={classes.commonPass}>
            {t("sign_up.password_is_too_common")}
          </p>
        )}
      </div>
      <div
        className={
          i18n.language === "en" ? classes.passHint : classes.passHintRtl
        }
      >
        <p>{t("sign_up.password_must")}</p>
        <p
          className={
            validEightCharacter.test(password) ? classes.correctRegex : ""
          }
        >
          {t("sign_up.eight_character")}
        </p>
        <p
          className={
            validOneUpperCase.test(password) ? classes.correctRegex : ""
          }
        >
          {t("sign_up.include_capital_letter")}
        </p>
        <p className={validNumber.test(password) ? classes.correctRegex : ""}>
          {t("sign_up.include_numbers")}
        </p>
        <p className={validOneDot.test(password) ? classes.correctRegex : ""}>
          {t("sign_up.and_include_spacial_character")}
        </p>
      </div>
    </div>
  );
};

export default SignUpOne;
